<!-- 
CustTagView.vue
功能：客戶標籤管理(view)
作者：i9400538 陳博承
完成：2021-10-19
-->
<template>
  <main>
    <tab-header />
    <div class="tab-pane active show">
      <form class="form">
        <section class="segment segment-padding">
          <div>
            <label class="title padding-left-25">客戶標籤定義與維護窗口</label>
          </div>
          <br />
          <div class="row padding-left-18">
            <!-- 定義 -->
            <div class="col-12">
              <div class="form-group row">
                <label for="description" class="col-2 text-right">客戶標籤說明</label>
                <div class="col-10 d-flex">
                  <textarea
                    :id="`description-${colKey}`"
                    :data-vv-name="`description-${colKey}`"
                    placeholder="請輸入客戶標籤說明"
                    v-model="custTagInfo.description"
                    v-validate="'required'"
                    data-vv-as="客戶標籤說明"
                    class="form-control"
                    :class="{ 'is-invalid': errors.has(`description-${colKey}`) }"
                    alt="ch"
                    rows="3"
                    cols="30"
                    maxlength="70"
                    @input="checkInputDescription"
                  ></textarea>
                </div>
                <label for="description" class="col-2 text-right"></label>
                <div class="col-10 d-flex">
                  <span>限70個字(中文、英文、數字、符號、空格)，目前已輸入{{custTagInfo.description.length}}個字</span>
                </div>
              </div>
            </div>
            <!-- 維護單位-->
            <div class="col-12">
              <div class="form-group row">
                <label for="dev_name" class="col-2 text-right">維護單位</label>
                <div class="col-10 d-flex">
                  <input
                    type="text"
                    maxlength="10"
                    :id="`dev_name-${colKey}`"
                    :data-vv-name="`dev_name-${colKey}`"
                    placeholder="請輸入維護單位"
                    v-model="custTagInfo.dev_name"
                    v-validate="'required'"
                    data-vv-as="維護單位"
                    class="form-control input-50"
                    :class="{ 'is-invalid': errors.has(`dev_name-${colKey}`) }"
                    alt="ch"
                    @input="checkInputDevName"
                  />
                </div>
              </div>
            </div>
            <!-- 聯絡電話-->
            <div class="col-12">
              <div class="form-group row">
                <label for="contact" class="col-2 text-right">聯絡電話</label>
                <div class="col-10 d-flex">
                  <span class="text">(</span>
                  <input
                    type="tel"
                    maxlength="3"
                    :id="`contact-0-${colKey}`"
                    :data-vv-name="`contact-0-${colKey}`"
                    placeholder="區碼"
                    v-model="custTagInfo.contact[0]"
                    v-validate="'required'"
                    data-vv-as="區碼"
                    class="form-control form-control-inline form-short"
                    :class="{ 'is-invalid': errors.has(`contact-0-${colKey}`) }"
                    @input="checkInputContact0"
                  />
                  <span class="text">)</span>
                  <input
                    type="tel"
                    maxlength="10"
                    :id="`contact-1-${colKey}`"
                    :data-vv-name="`contact-1-${colKey}`"
                    placeholder="電話號碼"
                    v-model="custTagInfo.contact[1]"
                    v-validate="'required'"
                    data-vv-as="電話號碼"
                    class="form-control form-control-inline"
                    :class="{ 'is-invalid': errors.has(`contact-1-${colKey}`) }"
                    @input="checkInputContact1"
                  />
                </div>
              </div>
            </div>
            <!-- 聯絡分機-->
            <div class="col-12">
              <div class="form-group row">
                <label for="contact_tel" class="col-2 text-right">聯絡分機</label>
                <div class="col-10 d-flex">
                  <input
                    type="text"
                    maxlength="20"
                    :id="`contact_tel-${colKey}`"
                    :data-vv-name="`contact_tel-${colKey}`"
                    placeholder="聯絡分機"
                    v-model="custTagInfo.contact_tel"
                    v-validate="'required'"
                    data-vv-as="聯絡分機"
                    :class="{ 'is-invalid': errors.has(`contact_tel-${colKey}`) }"
                    class="form-control form-control-inline"
                    @input="checkInputContactTel"
                  />
                </div>
              </div>
            </div>
          </div>
          <label class="title padding-left-25">客戶標籤總覽</label>
          <button type="button" class="add-btn" @click="doAdd">
            <span class="text">+新增標籤</span>
          </button>
          <br />
          <div class="padding-left-25">
            <div class="radio radio-inline">
              <input type="radio" v-model="type" id="type-1" value="1" />
              <label for="type-1">上架中</label>
            </div>
            <div class="radio radio-inline">
              <input type="radio" v-model="type" id="type-2" value="2" />
              <label for="type-2">已下架</label>
            </div>
          </div>
          <center>
            <div class="row">
              <!-- 上架中 -->
              <section class="w-100" v-show="type=='1'">
                <table
                  id="active_datatable"
                  class="table datatable table-striped area-list-datatable"
                >
                  <thead>
                    <tr>
                      <th width="80px">#</th>
                      <th id="col_cust_tag_name" class="text-center">標籤名稱</th>
                      <th id="col_sort" class="text-center">標籤排序</th>
                      <th id="col_function" ref="lastCol" class="text-center">功能</th>
                    </tr>
                  </thead>
                  <tbody id="area" v-if="custTagList.length" :style="`height: ${dt_height}px`">
                    <tr
                      v-for="(item, index) in custTagList"
                      :key="`td-custTagList-${index}-${item.tag_id}`"
                    >
                      <td width="80px">
                        <span class="no">{{index+1}}</span>
                      </td>
                      <td>{{item.tag_show_name ? item.tag_show_name : item.tag_name}}</td>
                      <td class="text-center">
                        <span @click="sortUp(index)">
                          <img
                            :src="`${BaseUrl}assets/tagicon/arrow-up.png`"
                            width="20"
                            class="link-pointer"
                            alt="up"
                          />
                        </span>
                        <span @click="sortDown(index)" class="padding-left-5p">
                          <img
                            :src="`${BaseUrl}assets/tagicon/arrow-down.png`"
                            width="20"
                            class="link-pointer"
                            alt="down"
                          />
                        </span>
                      </td>
                      <td :width="iPadWidth" class="text-center">
                        <a class="text-green text-underline pointer-cursor" @click="doEdit(item)">編輯</a>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="4" class="empty">
                        <h3 class="text-center py-5">查無資料，請確認您輸入之資料是否正確</h3>
                      </td>
                      <td v-show="false"></td>
                      <td v-show="false"></td>
                      <td v-show="false"></td>
                    </tr>
                  </tbody>
                </table>
              </section>
              <!-- 已下架 -->
              <section class="w-100" v-show="type=='2'">
                <table
                  id="unactive_datatable"
                  class="table datatable table-striped area-list-datatable"
                >
                  <thead>
                    <tr>
                      <th width="80px">#</th>
                      <th id="col_cust_tag_name_unactive" class="text-center">標籤名稱</th>
                      <th id="col_sort_unactive" class="text-center">標籤排序</th>
                      <th id="col_function_unactive" ref="lastCol" class="text-center">功能</th>
                    </tr>
                  </thead>
                  <tbody
                    id="area"
                    v-if="custTagList_unActive.length"
                    :style="`height: ${dt_height}px`"
                  >
                    <tr
                      v-for="(item, index) in custTagList_unActive"
                      :key="`td-custTagList-unactive-${index}-${item.tag_id}`"
                    >
                      <td width="80px">
                        <span class="no">{{index+1}}</span>
                      </td>
                      <td>{{item.tag_show_name ? item.tag_show_name : item.tag_name}}</td>
                      <td class="text-center">
                        <span>
                          <img
                            :src="`${BaseUrl}assets/tagicon/arrow-up-disabled.png`"
                            width="20"
                            alt="up"
                          />
                        </span>
                        <span class="padding-left-5p">
                          <img
                            :src="`${BaseUrl}assets/tagicon/arrow-down-disabled.png`"
                            width="20"
                            alt="down"
                          />
                        </span>
                      </td>
                      <td :width="iPadWidth" class="text-center">
                        <a class="text-green text-underline pointer-cursor" @click="doEdit(item)">編輯</a>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="4" class="empty">
                        <h3 class="text-center py-5">查無資料，請確認您輸入之資料是否正確</h3>
                      </td>
                      <td v-show="false"></td>
                      <td v-show="false"></td>
                      <td v-show="false"></td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
            <div class="action">
              <button type="button" @click.stop.prevent="doSubmit()" class="btn btn-primary">確認</button>
            </div>
          </center>
        </section>
      </form>
    </div>

    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" :content="mxMsgContent" />
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";
//component
import TabHeader from "@/desktop/components/backend/TabHeaderCustTag";
import mxMask from "@/desktop/components/mxMask";
//service
import { queryAllTagAndDef, updateDefAndSort } from "@/service";

//parameter
const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad

export default {
  name: "CustTagView",
  mixins: [commonMixin],
  components: {
    TabHeader,
    mxMask
  },
  data() {
    return {
      custTagInfo: {
        function_name: "", //功能名稱
        description: "", //功能說明
        dev_name: "", //維護單位
        contact: ["", ""], //維護單位電話
        contact_tel: "" //維護單位分機
      },
      custTagList: [], //客戶標籤(上架中)
      custTagList_unActive: [], //客戶標籤(已下架)
      dt_height: 0, //DataTable高度
      mxMaskOpen: false,
      mxMsgContent: "",
      scrollPostion: 25, // 顯示當前位置
      scrollPostionOffset: 10, // 1次render筆數
      iPadWidth: 364,
      colKey: "1",
      type: "1"
    };
  },
  computed: {
    ...mapGetters(["BaseUrl", "UserInfo"])
  },
  methods: {
    ...mapActions(["setPageLock"]),
    //檢查客戶標籤說明
    checkInputDescription() {
      this.custTagInfo.description = this.custTagInfo.description.replace(
        "\n",
        ""
      ); //禁止換行
    },
    //檢查維護單位
    checkInputDevName() {
      this.custTagInfo.dev_name = this.custTagInfo.dev_name.replace(
        /[<>!@#$^&,."'?%*;()+-/_{}[\]|~`=\\\s]/g,
        ""
      );
    },
    //檢查連絡電話
    checkInputContact0() {
      this.custTagInfo.contact[0] = this.custTagInfo.contact[0].replace(
        /[^\d]/g,
        ""
      );
    },
    checkInputContact1() {
      this.custTagInfo.contact[1] = this.custTagInfo.contact[1].replace(
        /[^\d]/g,
        ""
      );
    },
    //檢查聯絡分機
    checkInputContactTel() {
      this.custTagInfo.contact_tel = this.custTagInfo.contact_tel.replace(
        /[^\d、~]/g,
        ""
      );
    },
    //新增
    doAdd() {
      this.$router.push({
        name: "backend-tab6-2",
        params: {
          editMode: "i"
        }
      });
    },
    //確認
    doSubmit() {
      //檢核
      this.$validator.validateAll().then(el => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach(s => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        }
        this.$validator.reset();
        let defMap = Object.assign({}, this.custTagInfo);
        defMap.contact =
          "(" + this.custTagInfo.contact[0] + ")" + this.custTagInfo.contact[1];

        let sortMap = this.custTagList.filter(item => {
          if (item.sn != parseInt(item.sort_order)) {
            return item;
          }
        });
        this.mxMsgContent = "資料異動中，請稍候...";
        this.mxMaskOpen = true;
        //更新
        updateDefAndSort(this.UserInfo.id, defMap, sortMap).then(result => {
          this.mxMaskOpen = false;
          if (result.header && result.header.status == "200") {
            this.setToastMsg("更新成功");
            this.init(); //更新成功, 執行重查
          } else {
            this.setToastMsg(result.header.message);
          }
        });
      });
    },
    //初始化
    init() {
      this.mxMsgContent = "資料讀取中，請稍候...";
      this.mxMaskOpen = true; //開啟遮罩
      queryAllTagAndDef(this.$store.state.userInfo.id).then(res => {
        this.mxMaskOpen = false; //關閉遮罩
        if (res.header && res.header.status === "200" && res.body.result) {
          //客戶標籤定義
          let def = res.body.result.cust_tag_def;
          this.custTagInfo.function_name = def.function_name || "";
          this.custTagInfo.description = def.description || "";
          this.custTagInfo.dev_name = def.dev_name || "";
          this.custTagInfo.contact_tel = def.contact_tel || "";
          let contact = def.contact || ""; //維護單位電話
          let leftIndex = contact.indexOf("(");
          let rightIndex = contact.indexOf(")");
          if (contact) {
            if (leftIndex !== -1 && rightIndex !== -1) {
              let splitleft = contact.split("(");
              let splitRight = splitleft[1].split(")");
              this.custTagInfo.contact[0] = splitRight[0] || "";
              this.custTagInfo.contact[1] = splitRight[1] || "";
            } else if (contact.indexOf("-") !== -1) {
              let splitDash = contact.split("-");
              this.custTagInfo.contact[0] = splitDash[0] || "";
              this.custTagInfo.contact[1] = splitDash[1] || "";
            }
          }
          //客戶標籤資料(上架中)
          this.custTagList = res.body.result.cust_tag_active.map(
            (item, index) => {
              item.sn = index + 1;
              return item;
            }
          );
          //客戶標籤資料(已下架)
          this.custTagList_unActive = res.body.result.cust_tag_unactive.map(
            (item, index) => {
              item.sn = index + 1;
              return item;
            }
          );
          this.registerHanlink(); // 難字顯示
        } else {
          //執行出錯,顯示錯誤訊息
          this.$toast.info({ title: res.header.message });
        }
      });
    },
    //畫面初始化(卷軸, 表格高度)
    resetPosition() {
      this.scrollPostion = 25;
      this.scrollPostionOffset = 10;
      this.dt_height = $(window).height() - 290;
    },
    //排序(up)
    sortUp(index) {
      if (index == 0) {
        return;
      }
      this.custTagList[index].sn = index;
      this.custTagList[index - 1].sn = index + 1;
      setTimeout(() => {
        this.custTagList.sort(this.sortCompareFun(1, "sn"));
        this.registerHanlink(); // 難字顯示
      }, 20);
    },
    //排序(down)
    sortDown(index) {
      if (index == this.custTagList.length - 1) {
        return;
      }
      this.custTagList[index].sn = index + 2;
      this.custTagList[index + 1].sn = index + 1;
      setTimeout(() => {
        this.custTagList.sort(this.sortCompareFun(1, "sn"));
        this.registerHanlink(); // 難字顯示
      }, 20);
    },
    //編輯
    doEdit(custTag) {
      this.$router.push({
        name: "backend-tab6-2",
        params: {
          custTagData: custTag,
          editMode: "m"
        }
      });
    },
    //欄位寬度初始化
    initColWidth() {
      if (!is_iPad) {
        this.iPadWidth = this.$refs.lastCol.clientWidth - 15;
      } else {
        this.iPadWidth = this.$refs.lastCol.clientWidth;
      }
    }
  },
  beforeMount() {
    //檢查使用者是否為通路科/數支科的人
    //檢查使用者是否有後台管理權限
    let divNo = this.UserInfo.divNo;
    let functionId = this.UserInfo.functionId || [];
    if (
      divNo !== "9400400" &&
      divNo !== "9N00200" &&
      !functionId.includes("4")
    ) {
      this.$router.push({ path: "/" });
    }
  },
  mounted() {
    this.initColWidth();
    this.init();
    let self = this;
    $(window).bind("resize", function() {
      self.dt_height = $(window).height() - 310;
      self.iPadWidth = self.$refs.lastCol.clientWidth;
      this.initColWidth();
    });
  }
};
</script>

<style lang="scss" scoped>
.link-pointer {
  cursor: pointer;
}
.segment-padding {
  padding: 1px 40px 10px 40px;
}
.text-center {
  text-align: center;
}
.table.datatable {
  width: 50%;
  tbody {
    tr > td {
      &:first-child {
        padding-top: 10px;
      }
    }
  }
}
textarea {
  width: 50%;
  resize: none;
}
.input-50 {
  width: 50%;
}
.padding-left-5p {
  padding-left: 5px;
}
.padding-left-18 {
  padding-left: 18%;
}
.padding-left-25 {
  padding-left: 25%;
}
.title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 0.5rem;
  font-family: inherit;
  line-height: 1.2;
}
.add-btn {
  border: 0px;
  border-radius: 4px;
  color: #ffffff;
  background-color: #ffc814;
  padding: 2px;
  margin: 5px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
}
</style>
